import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import SingleDropDown from "../SingleDropDown";
import CheckboxWithLabel from "../CheckboxWithLabel";
import { useState, useRef, useEffect } from "react";
import ToggleButtons from "./ToggleButtons";
import GenderAutocomplete from "./GenderAutocomplete";
import TooltipIcon from "../TooltipIcon/TooltipIcon";
const _spacing = "10px";

//The states that require Purpose and Attention: AK, AL, AZ, CO, CT, GA, HI, MD, MS, MT, NC, ND, NM, PA, VA, WA and WY.
const purposeCodesForKq = ["C", "F", "E", "D", "J", "S"];
const statesRequiringPurpose = [
  "AK",
  "AL",
  "AZ",
  "CO",
  "CT",
  "GA",
  "HI",
  "MD",
  "MS",
  "MT",
  "NC",
  "ND",
  "NM",
  "PA",
  "VA",
  "WA",
  "WY",
];

const KqForm = props => {
  const inputLabel = useRef(null);
  const nameInputRef = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const [toggleOption, setToggleOption] = useState(0);
  const [acceptablePurposeCodes, setAcceptablePurposeCodes] = useState([]);

  useEffect(() => {
    let arr = [];
    arr = props.purposeCodes?.filter(code =>
      purposeCodesForKq.includes(code.value)
    );
    setAcceptablePurposeCodes(arr);
  }, [props.purposeCodes]);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    // Focus the Name field when switching from the OLN query option.
    if (toggleOption === 1) nameInputRef.current?.focus();
  }, [toggleOption]);

  const handleChange = e => {
    let value;
    let name;
    if (e.target.type === "checkbox") {
      value = e.target.checked;
      name = e.target.value;
    } else {
      name = e.target.name;
      value = e.target.value;
    }
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };

  const Oln = () => {
    return (
      <TextField
        variant="outlined"
        inputProps={{ "data-cy": "oln-input" }}
        InputLabelProps={{ shrink: true, "data-cy": "oln-input-label" }}
        margin="dense"
        id="oln-id"
        label="Operator's License Number"
        value={props?.queryState?.oln || ""}
        onChange={handleChange}
        name="oln"
        style={{ width: "45%" }}
      />
    );
  };
  const NameDobGender = () => {
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus Name when the Name/DOB query form opens. */}
        <TextField autoFocus
          inputRef={nameInputRef}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-id"
          label="Name"
          helperText="Last Name, First Name Middle Initial"
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
        />

        <GenderAutocomplete
          value={props?.queryState?.gender}
          handleChange={handleChange}
        />
      </>
    );
  };

  const formOptions = [Oln, NameDobGender];

  return (
    <div
      data-testid="kq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[{ name: "OLN" }, { name: "Name/DOB/Gender" }]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
      <div style={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
        <p style={{ fontWeight: "bold", margin: 0 }}>Conditional Fields</p>
        <TooltipIcon
          hoverText="These fields may be required or not allowed"
          text="These fields may be required or not allowed based on the state selected in the Destination field above. Refer to the state-specific guidelines from NLETs for more information."
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <CheckboxWithLabel
          formStyle={""}
          checked={props?.queryState?.imq}
          onChange={handleChange}
          stateName={"imq"}
          title={"License Photo (Optional)"}
          canEdit={true}
        />
        <SingleDropDown
          title={"Purpose"}
          value={props?.queryState?.purpose}
          stateName={"purpose"}
          options={acceptablePurposeCodes}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
          required={
            statesRequiringPurpose.includes(props?.destination?.name) || false
          }
          error={
            (!props?.queryState?.purpose &&
              statesRequiringPurpose.includes(props?.destination?.name)) ||
            false
          }
          helperText={
            !props?.queryState?.purpose &&
            statesRequiringPurpose.includes(props?.destination?.name)
              ? "Purpose is required for this state."
              : ""
          }
        />
        {/* 30 character max */}
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="attention-id"
          label="Attention"
          value={props?.queryState?.attention || ""}
          onChange={handleChange}
          name="attention"
          style={{ width: "45%" }}
          error={
            props?.queryState?.attention?.length > 30 ||
            (!props?.queryState?.attention &&
              statesRequiringPurpose.includes(props?.destination?.name))
          }
          helperText={
            props?.queryState?.attention?.length > 30
              ? "Maximum of 30 characters allowed."
              : !props?.queryState?.attention &&
                statesRequiringPurpose.includes(props?.destination?.name)
              ? "Purpose is required for this state."
              : ""
          }
        />
      </div>
    </div>
  );
};

export default KqForm;
